import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

const CompanyLogin = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    window.location.href = "https://company.voyagian.com/company-login";
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault(); // prevent page reload
    
    window.location.href = "https://company.voyagian.com/company-login";
  };

  return (
    <>
      <Header />

      {/* HERO */}
      <section className="hero1" style={{ marginTop: "80px" }}>
        <div className="container-lg">
          <div className="row g-3 justify-content-center">
            <div className="col-lg-8 py-4">
              <h3 style={{ textTransform: "uppercase" }} className="fw-bold">
                Login
              </h3>
            </div>
          </div>
        </div>
      </section>

      {/* LOGIN SECTION */}
      <section className="features py-5">
        <div className="container-lg">
          <div className="row g-4 justify-content-center">
            {/* Login Form */}
            <div className="col-lg-5">
              <div className="contact-card destination">
                <h4 className="fw-bold mb-3">Login to Company</h4>
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">Company</label>
                    <select id="company" className="form-select">
                      <option value="">Select a company</option>
                      <option value="Sabihat marine Services">
                        Sabihat marine Services
                      </option>
                      <option value="Diwanya Transprt">
                        Diwanya Transprt
                      </option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Username</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter your Username"
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Password</label>
                    <div className="input-group position-relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        placeholder="Enter your Password"
                      />
                      <button
                        type="button"
                        className="btn position-absolute top-50 end-0 translate-middle-y border-0 pe-3"
                        onClick={() => setShowPassword(!showPassword)}
                        style={{ zIndex: 10, background: "transparent" }}
                        tabIndex="-1"
                      >
                        <i className={`bi ${showPassword ? "bi-eye-slash-fill" : "bi-eye-fill"} text-muted`}></i>
                      </button>
                    </div>
                  </div>

                  <button type="submit" className="btn btn-primary-navy w-100">
                    Login
                  </button>
                </form>
              </div>
            </div>

            {/* (Right side is empty in original layout, so we keep only this column) */}
          </div>
        </div>
      </section>

      {/* FOOTER (page-specific, as in HTML) */}
      <footer>
        <div className="footer-top">
          <div className="container-lg">
            <div className="row g-4">
              <div className="col-md-4">
                <div className="footer-title">Important Links</div>
                <a className="footer-link" href="#">
                  Home
                </a>
                <a className="footer-link" href="#">
                  Who We Are
                </a>
                <a className="footer-link" href="#">
                  Contact Us
                </a>
                <a className="footer-link" href="#">
                  Destinations
                </a>
                <a className="footer-link" href="#">
                  Promotions
                </a>
              </div>

              <div className="col-md-4">
                <div className="footer-title">Contact Info</div>
                <div>123 Marina Blvd, Suite 100</div>
                <div>Port City, Coastal Region 54321</div>
                <div>Country</div>
                <div className="mt-2">Email: info@sabihatmarine.com</div>
                <div>Phone: +1 (234) 567-890</div>
              </div>

              <div className="col-md-4">
                <div className="footer-title">Follow Us</div>
                <div className="social">
                  <a href="#">
                    <i className="bi bi-whatsapp"></i>
                  </a>
                  <a href="#" className="ms-3">
                    <i className="bi bi-facebook"></i>
                  </a>
                  <a href="#" className="ms-3">
                    <i className="bi bi-instagram"></i>
                  </a>
                  <a href="#" className="ms-3">
                    <i className="bi bi-linkedin"></i>
                  </a>
                  <a href="#" className="ms-3">
                    <i className="bi bi-google"></i>
                  </a>
                </div>
                <div className="mt-3 text-white">
                  Powered by Voyagian System
                  <br />
                  Seamless Voyage and Smart Operation
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="container text-center">
            <p>© 2025 VOYAGIAN. Powered by Ferry SaaS</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default CompanyLogin;
